import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { unsubscribe } from '../lib/emailLinks';
import PageTitle from '../components/ui/PageTitle';
import './EmailLinkPages.css';

// /unsubscribe/:token - the link at the bottom of reminder and follow-up
// emails. It waits for a click (email scanners open links on their own,
// and must not unsubscribe anyone).
export default function UnsubscribePage() {
  var token = useParams().token;
  var [state, setState] = useState('ask'); // ask | busy | done | error
  var [email, setEmail] = useState('');
  var [error, setError] = useState('');

  async function confirm() {
    if (state === 'busy') return;
    setState('busy');
    var r = await unsubscribe(token);
    if (r.error) { setError(r.error); setState('error'); return; }
    setEmail(r.email);
    setState('done');
  }

  return (
    <>
      <PageTitle title="Unsubscribe" />
      <div className="el-page">
        <div className="el-card">
          {state === 'done' ? (
            <>
              <h1 className="el-heading">You&rsquo;re unsubscribed</h1>
              <p className="el-body" role="status">
                {email ? <strong>{email}</strong> : 'Your address'} won&rsquo;t get any more reminders, follow-ups or newsletters from Andre M Leather.
              </p>
              <p className="el-note">If you place an order, you&rsquo;ll still get its confirmation and shipping emails.</p>
              <div className="el-actions">
                <Link to="/" className="el-btn-ghost">Go to homepage</Link>
              </div>
            </>
          ) : (
            <>
              <h1 className="el-heading">Stop reminder emails?</h1>
              <p className="el-body">
                You won&rsquo;t get bag reminders, follow-ups after delivery or newsletters any more. Order confirmations and shipping updates still come.
              </p>
              {state === 'error' && <p className="el-error" role="alert">{error}</p>}
              <div className="el-actions">
                <button type="button" className="el-btn-primary" onClick={confirm} disabled={state === 'busy'}>
                  {state === 'busy' ? 'Unsubscribing…' : 'Unsubscribe'}
                </button>
                <Link to="/" className="el-btn-ghost">Keep my emails</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
